import { Injectable } from '@angular/core';
import { BackendService } from './backend.service';
import { CARD_BY_ICCID, CARDS_BY_USER } from './gql_queries/cards.service.gql';
import { CdrData } from './cdrs.service';

export interface CardData {
  "__typename"?: string,
  id: string,
  createdAt: string,
  subscriptionStart: string,
  subscriptionEnd: string,
  lastUsed: string,
  lastUsedLocation: string,
  iccid: string,
  imei: string,
  imsi: string,
  msisdn: string,
  currentPricePlan: {
    name: string
  },
  status: string,
  minutesLeft?: number,
  minutesUsed?: number,
  validUntil: string,
  userId?: string,
  pin1?: string,
  pin2?: string,
  puk1?: string,
  puk2?: string
}

interface CardDataSets {
  activated?: CardData[],
  archived?: CardData[],
  dormant?: CardData[],
  tobeVerified?: CardData[]
}

interface CardsByUserResponseFromServer {
  error?: string,
  data?: {
    cardsByUser: CardDataSets
  }
}

interface CardsByIccidResponseFromServer {
  error?: string,
  data?: {
    cardsByIccid: CardDataSets
  }
}

interface CardByIccidResponseFromServer {
  error?: string,
  data?: {
    cardByIccid: FullCardData[]
  }
}

interface SqsResponseFromServer {
  error?: string,
  data?: {
    [key: string]: {
      id?: string,
      statusCode: number,
      success: boolean
    }
  }
}

export type FullCardData = CardData | CdrData;
export type FullCardInfo = {
  card?: CardData,
  cdrs?: CdrData[]
}

@Injectable({
  providedIn: 'root'
})
export class CardService {

  constructor(
    private readonly backendService: BackendService
  ) {
  }

  async getCardsByUser(userId: string): Promise<CardDataSets> {
    const result = await this.backendService.executeGraphQL(
      CARDS_BY_USER,
      {
        userId
      }
    ) as CardsByUserResponseFromServer;

    if (result.data != null && result.data.cardsByUser != null) {
      return result.data.cardsByUser;
    }
    return {};
  }

  async getCardDetails(iccid: string): Promise<FullCardInfo | null> {
    const result = await this.backendService.executeGraphQL(
      CARD_BY_ICCID,
      {
        iccid
      }
    ) as CardByIccidResponseFromServer;

    if (result.data != null && result.data.cardByIccid != null) {
      const fullCardInfo: FullCardInfo = {cdrs: []};
      result.data.cardByIccid.forEach(fullCardRow => {
        if (fullCardRow['__typename'] === 'Card') {
          fullCardInfo.card = fullCardRow as CardData;
        } else if (fullCardRow['__typename'] === 'Cdr') {
          fullCardInfo.cdrs!.push(fullCardRow as CdrData);
        } else {
          console.error(`Unknown typename in a row:`, fullCardRow);
        }
      });
      return fullCardInfo;
    }
    return null;
  }

  async orderBilling(iccid: string): Promise<void> {
    const result = await this.backendService.executeGraphQL(
      `
mutation orderBilling($iccid: String!) {
  orderBilling(iccid: $iccid) {
    messageId
    statusCode
    success
  }
}
`,
      {
        iccid
      }
    ) as SqsResponseFromServer;
    console.log('orderBilling result:', result);
  }
}
